import React from "react";
import { Table, Button, Badge } from "react-bootstrap";
import EditHistory from "./EditHistory";
import { format } from "date-fns";

export default function ListHistory({
  dataList,
  handleDelete,
  getData,
  dataService,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return format(new Date(dateString), "MMM dd, yyyy HH:mm");
    } catch (error) {
      return "Invalid Date";
    }
  };

  return (
    <div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Search Query</th>
            <th>Count</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dataList?.map((data, idx) => (
            <tr key={idx}>
              <td>
                <div style={{ maxWidth: "400px" }}>{data.query || "N/A"}</div>
              </td>
              <td>
                <Badge bg="info">{data.count || 0}</Badge>
              </td>

              <td>{formatDate(data.createdAt)}</td>
              <td>{formatDate(data.updatedAt)}</td>
              <td>
                <div className="d-flex gap-2">
                  <EditHistory
                    data={data}
                    getData={getData}
                    dataService={dataService}
                  />
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={(e) => handleDelete(e, data)}
                  >
                    <i className="bi bi-trash"></i>
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
